import { makeTypescriptEnumSchema } from '../../enumSchemas';

/**
 * Plain login enums and their enum schemas, kept in a standalone module that does NOT
 * construct the heavy Login vault schema graph. Importing just these constants therefore
 * does not pull in the full Login schema tree (Login, revisions, password-policy/origin
 * unions, sub-schemas). The content script needs these enums but never parses a Login, so
 * this keeps that schema tree out of the per-iframe content bundle.
 */

export enum LoginUiType {
  login = 'login',
  creditCard = 'creditCard',
  note = 'note',
  wifi = 'wifi',
  passkey = 'passkey',
  elsterCertificate = 'elsterCertificate',
}

export const schemaLoginUiType = makeTypescriptEnumSchema(LoginUiType, LoginUiType.login);

export enum LoginSource {
  manual = 'manual',
  autosave = 'autosave',
  registrationPasswordGeneration = 'registrationPasswordGeneration',
  addTotpFromOverlay = 'addTotpFromOverlay',
  updateLoginFromOverlay = 'updateLoginFromOverlay',
  menuDragDrop = 'menuDragDrop',
  import = 'import',
  shareLink = 'shareLink',
  undo = 'undo',
  addTotpFromApp = 'addTotpFromApp',
  duplicateLogin = 'duplicateLogin',
  addPasskeyFromOverlay = 'addPasskeyFromOverlay',
  addPasskeyFromApp = 'addPasskeyFromApp',
  renameTag = 'renameTag',
}

export const schemaLoginSource = makeTypescriptEnumSchema(LoginSource, undefined);
